import { Link } from "react-router-dom";
import { CITIES_COL1, CITIES_COL2 } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { GoogleMap } from "@/components/GoogleMap";

export const ZonesSection = () => (
  <section className="py-16 lg:py-28 bg-surface-canvas relative overflow-hidden" data-testid="zones-section">
    {/* Forme decorative discrete - dégradé bleu pâle, purement visuel */}
    <div
      className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full pointer-events-none"
      style={{ background: "radial-gradient(circle, rgba(30,79,168,0.12) 0%, rgba(74,130,214,0.06) 45%, transparent 70%)" }}
      aria-hidden="true"
    />
    <div className="max-w-site mx-auto px-5 lg:px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center relative">
      <Reveal>
        <p className="micro-label mb-4">Où on intervient</p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-[44px] leading-[1.1] text-brand-deep">
          On se déplace dans votre commune.
        </h2>
        <p className="mt-5 text-base md:text-lg text-ink-secondary max-w-[520px]">
          Basés à Coulounieix-Chamiers, on intervient partout en Dordogne, dans le Lot, en Corrèze, en Haute-Vienne et en Charente.
        </p>
        <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-3">
          <div className="flex flex-wrap gap-2.5 content-start">
            {CITIES_COL1.map((c) => (
              <Link key={c} to="/zones-intervention" className="chip-city" data-testid={`city-chip-${c.toLowerCase().replace(/[^a-z]/g, "")}`}>{c}</Link>
            ))}
          </div>
          <div className="flex flex-wrap gap-2.5 content-start">
            {CITIES_COL2.map((c) => (
              <Link key={c} to="/zones-intervention" className="chip-city">{c}</Link>
            ))}
          </div>
        </div>
        <p className="mt-6 text-sm text-ink-secondary">
          Votre commune n'y figure pas ? Appelez-nous, on se déplace au-delà.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <GoogleMap height={520} />
      </Reveal>
    </div>
  </section>
);
